import gql from 'graphql-tag';

const ReservationHoursByInstitutionQuery = gql`
  query ReservationHoursByInstitution($from: Int, $to: Int, $category: String) {
    reservationHoursByInstitution(from: $from, to: $to, category: $category)
  }
`;

export default ReservationHoursByInstitutionQuery;
